import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CalendarClock } from "lucide-react";

const KEY = "cc_booking_reminder_dismissed";

// Reminds a student about any 'book a meeting' task they haven't scheduled — once per day.
export function BookingReminder({ alerts }) {
  const [open, setOpen] = useState(false);
  const list = alerts || [];
  const signature = list.map((a) => a.task_id).join(",");

  useEffect(() => {
    if (!signature) return;
    const today = new Date().toISOString().slice(0, 10);
    if (localStorage.getItem(KEY) !== `${today}|${signature}`) setOpen(true);
  }, [signature]);

  const dismiss = () => {
    const today = new Date().toISOString().slice(0, 10);
    localStorage.setItem(KEY, `${today}|${signature}`);
    setOpen(false);
  };

  if (list.length === 0) return null;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && dismiss()}>
      <DialogContent data-testid="booking-reminder-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CalendarClock className="w-5 h-5 text-cc-orange" />
            {list.length === 1 ? "One thing to book" : `${list.length} things to book`}
          </DialogTitle>
          <DialogDescription>
            Pick a day and time that suits you — your Campus Coordinator confirms it from there.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          {list.map((a) => (
            <div key={a.task_id} className="border rounded-md px-3 py-2.5" data-testid={`booking-alert-${a.task_id}`}>
              <p className="font-medium text-sm text-zinc-900">{a.title}</p>
              {a.description && <p className="text-xs text-zinc-500 mt-0.5">{a.description}</p>}
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={dismiss} data-testid="booking-remind-later">Remind me tomorrow</Button>
          <Button onClick={dismiss} className="bg-cc-blue hover:bg-cc-blue-dark text-white" data-testid="booking-goto-tasks">
            Book it on my checklist
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
